
import anime from 'animejs/lib/anime.es'
import React, { useEffect, useRef } from 'react'

const elements = Array.from(Array(100))

const Animate = () => {

  const animation = useRef(null)

  useEffect(() => {
    animation.current = anime.timeline({
      targets: ".element",
      easing: 'easeInOutExpo',
      loop: true,
      autoplay: true,
      delay: anime.stagger(70, {grid:[10, 10], from: "center"})
    });

    animation.current
    .add({
      borderRadius: 20,
      rotateZ: 180,
      translateY: anime.stagger(-20, {grid:[10, 10], from: "center", axis:'y'}),
      translateX: anime.stagger(-20, {grid:[10, 10], from: "center", axis:'x'}),
      opacity: .6,
    })
    .add({
      borderRadius: 50,
      opacity: .7,
    })
    .add({
      scale: 0.3,
      opacity: .6,
      delay: anime.stagger(100, {grid:[10, 10], from: "center"})
    })
      animation.current
    .add({
      borderRadius: 50,
      translateY: anime.stagger(0, {grid:[10, 10], from: "center", axis:'y'}),
      translateX: anime.stagger(0, {grid:[10, 10], from: "center", axis:'x'}),
      opacity: .6,
    })
    .add({
      borderRadius: 50,
      scale: 1,
      opacity: .3,
      delay: anime.stagger(200, {grid:[10, 10], from: "center"})
    })
    .add({
      borderRadius: 20,
      opacity: .6,
    })
    
  }, [])

  return (
    <div className='animation__container'>
      {
        elements.map((_, id)=>{
          return (
            <div className='element' key={id}></div>
          )
        })
      }
    </div>
  )
}

export default Animate
